import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'megastore-admin-view-rack',
  templateUrl: './view-rack.component.html',
  styleUrls: ['./view-rack.component.scss']
})
export class ViewRackComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ViewRackComponent>,
    private router: Router,
    public translate: TranslateService,
  ) { }

  getTotalQuantity(shelf: any): number {
    return shelf.items.reduce((sum: number, item: any) => sum + item.quantity, 0);
  }

  navigateToProduct(variantId: string): void {
    this.router.navigate(['/products/list/1/inventory', variantId]);
    this.dialogRef.close();
  }


  viewAllProducts(shelfId: string): void {
    this.router.navigate(['/products/list', 1], { queryParams: { shelfId } });
  }

}